export default "__VITE_ASSET__f96afc1c__"